import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';

@Component({
    selector: 'app-equipment-tab-list-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './equipment-tab-list-item.component.html',
})
export class EquipmentTabListItemComponent implements OnInit {

    @Input() equipment: EquipmentCardInterfaces.Card.ItemView;
    @Input() isFetching = false;
    @Input() showRemove = true;

    @Output() remove = new EventEmitter();

    @HostBinding('class') private className = 'tab-list-item';

    constructor() {
    }

    ngOnInit() {
    }

}
